const projectDetails = [
	{
		title: 'TutorApp',
		subtitle: 'Laravel, PHP, React, MySQL',
		description: 'A web application for tutors to record student information, schedule lessons, record payments, track income and quickly communicate with clients. It was built within the Laravel framework. The backend is written in PHP and connects to a MySQL database. The frontend is written in React. Other tools include Bootstrap, Sass, Font-Awesome, Mailgun, Git, and Heroku.',
		image_link: 'https://res.cloudinary.com/dfonttj4w/image/upload/c_scale,h_250,q_100,w_350/v1555794887/portfolio/TutorApp4.png',
		web_link: 'https://my-tutor-app.herokuapp.com/',
		github_link: 'https://github.com/Brian-T-Hart/tutor-tool',
		tags: ['laravel', 'mysql', 'php', 'react']
	},
	{
		title: 'WCHS Worlviews',
		subtitle: 'MySQL, Express, React, Node',
		description: 'I had a lot of fun working on this React app that I made for a high school Life Calling class. The web app allows students to record and track information regarding their personality and strengths as they take various tests throughout the year. After each test, the students select values from a list and the data is quickly populated to the screen and stored in a MySQL database for future retrieval. The app also allows for the upload of three documents in pdf, jpeg, or png format. The site was constructed using a MySQL database, Express, React, Node.js, and Cloudinary for document management. Github houses the repository. Git was used for source control. The site is deployed on Heroku.',
		image_link: 'https://res.cloudinary.com/dfonttj4w/image/upload/c_scale,h_250,q_100,w_350/v1555793979/portfolio/lifecalling1.png',
		web_link: 'https://wchs-lifecalling-demo.herokuapp.com/',
		github_link: 'https://github.com/Brian-T-Hart/WCHS-Lifecalling-demo',
		tags: ['cloudinary', 'express', 'mysql', 'node', 'react']
	},
	{
		title: 'ClassWorx',
		subtitle: 'MySQL, Express, Handlebars, Node',
		description: 'Teachers can gamify the classroom with ClassWorx online teaching tools. Create an account to add classes, add/edit students, track student points, hall passes, homework passes, and more. Feel free to login to an example account using "test@email.com" with "test" as the password.',
		image_link: 'https://res.cloudinary.com/dfonttj4w/image/upload/c_scale,h_250,q_100,w_350/v1555794214/portfolio/classworx1.png',
		web_link: 'https://class-worx.herokuapp.com',
		github_link: 'https://github.com/Brian-T-Hart/class-worx',
		tags: ['cloudinary', 'express', 'handlebars', 'mysql', 'node']
	},
	// {
	// 	title: 'Goal Post',
	// 	subtitle: 'MySQL, Express, React, Node',
	// 	description: 'Goal-Post is a React-based application that assists sales reps from small to mid-sized companies. It will allow companies to create a digital hub or dashboard for their sales reps, allowing them to efficiently schedule meetings and deliveries, and to track inventory and sales. Goal-Post was a group effort, the third and final project of the UCI Coding Bootcamp. I worked on a team of five and participated in many aspects, such as, building react components, incorporating Chart.js, designing the database and setting up controllers.',
	// 	image_link: 'https://res.cloudinary.com/dfonttj4w/image/upload/c_scale,h_250,q_100,w_350/v1556065536/portfolio/GoalPost.png',
	// 	web_link: 'https://goal-post-crm.herokuapp.com/',
	// 	github_link: 'https://github.com/Brian-T-Hart/bisque3',
	// 	tags: [ 'express', 'mysql', 'node', 'react']
	// },
	{
		title: 'GemmaList',
		subtitle: 'Laravel, PHP, MySQL',
		description: 'GemmaList is a todo app I built so that multiple lists can be viewed on the screen at one time. It was built using PHP, MySQL, and Blade within the Laravel framework. It utilizes Git and Gitub for source control and is hosted on Heroku.',
		image_link: 'https://res.cloudinary.com/dfonttj4w/image/upload/c_scale,h_250,q_100,w_350/v1555796136/portfolio/GemmaList2.png',
		web_link: 'https://www.gemmalist.com/',
		github_link: 'https://github.com/Brian-T-Hart/gemma-list',
		tags: ['laravel', 'php', 'mysql', 'blade']
	},
	{
		title: 'Tic-Tac-Toe',
		subtitle: 'HTML, CSS, Javascript',
		description: 'A game of Tic-Tac-Toe made with HTML, CSS, and JavaScript.',
		image_link: 'https://res.cloudinary.com/dfonttj4w/image/upload/c_scale,h_250,q_100,w_350/v1555796778/portfolio/tic-tac-toe.png',
		web_link: 'https://brian-t-hart.github.io/tic-tac-toe-vanilla/',
		github_link: 'https://github.com/Brian-T-Hart/tic-tac-toe-vanilla',
		tags: ['html', 'css', 'javascript']
	}
];

export default projectDetails;